import { render, staticRenderFns } from "./tablaPendientes.vue?vue&type=template&id=dfa71108&scoped=true"
import script from "./tablaPendientes.vue?vue&type=script&lang=js"
export * from "./tablaPendientes.vue?vue&type=script&lang=js"
import style0 from "./tablaPendientes.vue?vue&type=style&index=0&id=dfa71108&prod&scoped=true&lang=css"
import style1 from "./tablaPendientes.vue?vue&type=style&index=1&id=dfa71108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa71108",
  null
  
)

export default component.exports